/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 目标语言，支持：中文、英文
 */
export const PostTranslateStreamToLang = {
  Chinese: "中文",
  English: "英文",
} as const;
/**
 * 目标语言，支持：中文、英文
 */
export type PostTranslateStreamToLang = ClosedEnum<
  typeof PostTranslateStreamToLang
>;

export const PostTranslateStreamToLang$zodSchema = z.enum([
  "中文",
  "英文",
]).describe("目标语言，支持：中文、英文");

/**
 * 源语言，支持：中文、英文、auto（自动检测）。默认为auto
 */
export const FromLang = {
  Chinese: "中文",
  English: "英文",
  Auto: "auto",
} as const;
/**
 * 源语言，支持：中文、英文、auto（自动检测）。默认为auto
 */
export type FromLang = ClosedEnum<typeof FromLang>;

export const FromLang$zodSchema = z.enum([
  "中文",
  "英文",
  "auto",
]).describe("源语言，支持：中文、英文、auto（自动检测）。默认为auto");

/**
 * 包含翻译参数的JSON对象
 */
export type PostTranslateStreamRequest = {
  query: string;
  to_lang: PostTranslateStreamToLang;
  from_lang?: FromLang | undefined;
  tone?: string | undefined;
};

export const PostTranslateStreamRequest$zodSchema: z.ZodType<
  PostTranslateStreamRequest
> = z.object({
  from_lang: FromLang$zodSchema.default("auto"),
  query: z.string(),
  to_lang: PostTranslateStreamToLang$zodSchema,
  tone: z.string().optional(),
}).describe("包含翻译参数的JSON对象");

/**
 * 翻译服务错误
 */
export type PostTranslateStreamInternalServerErrorResponseBody = {
  error?: string | undefined;
  code?: string | undefined;
};

export const PostTranslateStreamInternalServerErrorResponseBody$zodSchema:
  z.ZodType<PostTranslateStreamInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    error: z.string().optional(),
  }).describe("翻译服务错误");

/**
 * 错误码
 */
export const Code = {
  InvalidRequest: "INVALID_REQUEST",
  MissingQuery: "MISSING_QUERY",
  MissingTargetLang: "MISSING_TARGET_LANG",
} as const;
/**
 * 错误码
 */
export type Code = ClosedEnum<typeof Code>;

export const Code$zodSchema = z.enum([
  "INVALID_REQUEST",
  "MISSING_QUERY",
  "MISSING_TARGET_LANG",
]).describe("错误码");

/**
 * 请求参数错误
 */
export type PostTranslateStreamBadRequestResponseBody = {
  error?: string | undefined;
  code?: Code | undefined;
};

export const PostTranslateStreamBadRequestResponseBody$zodSchema: z.ZodType<
  PostTranslateStreamBadRequestResponseBody
> = z.object({
  code: Code$zodSchema.optional(),
  error: z.string().optional(),
}).describe("请求参数错误");

export type PostTranslateStreamResponse =
  | string
  | PostTranslateStreamBadRequestResponseBody
  | PostTranslateStreamInternalServerErrorResponseBody;

export const PostTranslateStreamResponse$zodSchema: z.ZodType<
  PostTranslateStreamResponse
> = z.union([
  z.string().describe("SSE流式响应。Content-Type为text/event-stream"),
  z.lazy(() => PostTranslateStreamBadRequestResponseBody$zodSchema),
  z.lazy(() => PostTranslateStreamInternalServerErrorResponseBody$zodSchema),
]);
